<script setup lang="ts">
const props = withDefaults(defineProps<{
  html: string
  unsafe?: boolean
}>(), {
  unsafe: false,
})
</script>

<template>
  <div v-if="props.unsafe" v-html="props.html"></div>
  <div v-else v-dompurify-html="props.html"></div>
</template>
